import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import Home from "@/components/pages/Home";
import ShoppingCart from "@/components/pages/ShoppingCart";
import Category from "@/components/pages/Category";
const DEFAULT_TITLE = "Some Default Title";

export default new VueRouter({
  //   router,
  mode: "hash",
  routes: [
    {
      path: "/",
      component: Home,
      name: "home",
      meta: {
        title: "Store",
        metaTags: [
          {
            name: "description",
            content:
              "متجرنا يقدم العديد من المنتجات المتنوعة لكافة الفئات العمرية مع خدمة توصيل مميزة خلال 24 ساعة لجميع المناطق الأردنية"
          }
        ]
      }
    },
    { path: "/cart", component: ShoppingCart, name: "shoppingcart" },
    { path: "/cat/:id", component: Category, name: "Category" }
  ]
});
